import { RightWrapper } from "../../../components";
import { DownloadCard } from "@/components";
import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAlert, useConfirmationDialog, useApi } from "@/";
import { upsertAppliedRate } from "../../../app/Slices/customerAppliedRatesSlice";
import { useParams } from "react-router-dom";

const AppliedRates = () => {
  const dispatch = useDispatch();
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const { id } = useParams();
  const [selectedFile, setSelectedFile] = useState(null);
  const customerId = id;
  const { callApi, loading } = useApi();
  const handleDownload = useCallback(async () => {
    try {
      const filename = `applied_rates_${customerId}`;

      const response = await callApi(
        "/common/export",
        "POST",
        {
          model: "Admin_applied_rates",
          ids: [customerId],
          filename,
        },
        null,
        null,
        "blob"
      );

      const contentType = response?.headers?.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const errorData = await response.json();
        alert(errorData.message || "Download failed");
        return;
      }

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.csv`;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 100);
    } catch (error) {
      console.error("Download Error:", error);
      alert("An error occurred while downloading the applied rates");
    }
  }, [customerId, callApi]);

  const handleFileSelect = (file) => {
    setSelectedFile(file); // Store selected file
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file before uploading.");
      return;
    }

    if (!customerId) {
      alert("Customer ID is missing. Please log in again.");
      return;
    }
    await confirm("Are you sure you want to upload Rates?");
    try {
      const action = await dispatch(
        upsertAppliedRate({ rates: selectedFile, customerId })
      );

      if (upsertAppliedRate.fulfilled.match(action)) {
        await alert("Applied Rates Upserted Successfully", "success");
        setSelectedFile(null); // Clear file after upload
      } else {
        console.error("Applied Rates Upsertion Failed", action.payload);
        alert(action.payload || "Applied Rates Upsertion Failed");
      }
    } catch (error) {
      console.error("API Error:::", error);
      alert("An error occurred while uploading the applied rates.");
    }
  };

  return (
    <RightWrapper>
      <div className="flex flex-col gap-8 m-2 mt-4 pb-20 md:pb-4">
        <div className="flex flex-col md:flex-row lg:justify-between items-end gap-6 lg:gap-2">
          <div className="flex flex-col gap-1 w-full">
            <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
              Applied Rates
            </h1>
            <p className="text-body2 font-ptsans text-secondary/60 lg:w-[45%]">
              Below is the option to download and upload customer-specific rates
              for the specific customer.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-2 lg:gap-4 justify-start items-center">
          <DownloadCard
            title="Download Applied Rates"
            buttonText="Download"
            onClick={handleDownload}
            download={true}
            isLoading={loading}
          />

          <DownloadCard
            title="Upload Applied Rates"
            buttonText={selectedFile ? "Upload" : "Select File"}
            onClick={handleUpload}
            download={false}
            onFileUpload={handleFileSelect}
            selectedFile={selectedFile}
            accept=".csv"
          />
        </div>
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </RightWrapper>
  );
};

export default AppliedRates;
